import {
    Alert,
    Button,
    Checkbox, Container, FormControl, FormControlLabel,
    FormLabel, Grid,
    IconButton,
    InputAdornment,
    InputLabel,
    MenuItem,
    Paper, Radio, RadioGroup,
    Select,
    Stack,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography
} from "@mui/material";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from "dayjs";
import 'dayjs/locale/ko';
import { isEmpty } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { useDaumPostcodePopup } from 'react-daum-postcode';
import { Controller, useForm } from 'react-hook-form';
import toast from "react-hot-toast";
import { BsSearch } from "react-icons/bs";
import { Link, useNavigate } from 'react-router-dom';
import { apiService } from '../../../api/axiosClient';
import Page from 'src/components/Page';
import PageHeader from 'src/components/page-header';
import NewWindow from 'src/utils/newwindow';

const OrderRegister = () => {
    const navigate = useNavigate();
    const [list, setList] = useState([]);
    const [staff, setStaff] = useState([]);
    const [tot_supply, setTotSupply] = useState(0);
    const [tot_vat, setTotVat] = useState(0);
    const [tot_order, setTotOrder] = useState(0);    
    const [searchProductShow, setSearchProductShow] = useState(false);
    const [searcMemberShow, setSearchMemberShow] = useState(false);
    const [memfield, setMemField] = useState('username');
    const [memq, setMemQ] = useState('');
    const [member, setMember] = useState({});
    const [receiver, setReceiver] = useState();
    const open = useDaumPostcodePopup();
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
        setValue
    } = useForm()
    const memBtnRef = useRef(null);
    const postBtnRef = useRef(null);

    const fetchProductData = async (skus) => {
        const response = await apiService.get(`/products/skus?query=${skus}`)
        const payload = response.data;
        const newList = payload.list.map(item => {
            return {
                ...item,
                quantity: 1,
                supply_price: item.price,
                vat: 0.1 * item.price
            }
        });        
        
        setList(prevList => [...prevList, ...newList]);
    }

    const fetchStaffData = async (users) => {
        const response = await apiService.get('/staff');

        setStaff(response.data.list);
    }

    const handleUpdate = (list) => {
        const supply = list.reduce((acc, item) => acc + item.supply_price, 0);
        const vat = list.reduce((acc, item) => acc + item.vat, 0);

        setTotSupply(supply);
        setTotVat(vat);
        setTotOrder(supply + vat);
    }

    useEffect(() => {
        if (list) {
            handleUpdate(list);
        }
    }, [list]);

    useEffect(() => {
        fetchStaffData();
    }, []);

    window.productReceiver = (skus) => {
        fetchProductData(skus);
    }

    window.userReceiver = (user) => {
        if(isEmpty(user.com_id)) {
            toast.error('회사가 등록되지 않은 회원입니다. 회사정보를 등록 후 주문등록을 진행하세요',
                {
                    position: "top-center"
                }
            );
            return;
        }
        setMember(user);
        setReceiver(user);

        // 주문자 정보 설정
        setMemQ(user.username);
        setMemField('username');
    }

    const ProductSearchWindow = () => {
        return (
          searchProductShow ? (
            <NewWindow 
              url={"/find/product"} 
              title={"상품 검색"} 
              features = {{ left: '100px', top: '100px', width: '800px', height: '900px'}}
              onUnload={handleClose} /> ) 
            : ""
        )
    }

    const MemberSearchWindow = () => {
        return (
          searcMemberShow ? (
            <NewWindow 
              url={`/find/user?field=${memfield}&q=${memq}`} 
              title={"회원 검색"} 
              features = {{ left: '100px', top: '100px', width: '800px', height: '900px'}}
              onUnload={handleSearchClose} /> ) 
            : ""
        )
    }

    const handleComplete = (data) => {
        let fullAddress = data.address;
        let extraAddress = '';

        if (data.addressType === 'R') {
            if (data.bname !== '') {
                extraAddress += data.bname;
            }
            if (data.buildingName !== '') {
                extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
            }
            fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
        }

        setValue('order_r_zip', data.zonecode);
        setValue('order_r_addr1', fullAddress);
    };

    const handleClose = () => {
        postBtnRef.current.disabled = false;
        setSearchProductShow(false);
    }

    const handleClick = () => {
        postBtnRef.current.disabled = true;
        open({ onComplete: handleComplete, onClose: handleClose });
    };

    const handleDelete = (index) => {
        setList(list.filter((_, i) => i !== index));
    }

    const handleQuantityChange = (index, value) => {
        const updatedList = list.map((item, i) => {
            if (i === index) {
                return { ...item, 
                    quantity: value,
                    supply_price: item.price * value,
                    vat: 0.1 * item.price * value
                };
            }
            return item;
        });

        setList(updatedList);
    }

    const handleSearch = (e) => {
        e.preventDefault();

        memBtnRef.current.disabled = true;
        setSearchMemberShow(true);
    }

    const handleSearchClose = () => {
        memBtnRef.current.disabled = false;
        setSearchMemberShow(false);
    }

    useEffect(() => {
        const defaultValues = {
            com_charge: member.com_charge,
            com_name: member.com_name,
            phone: member.phone,
            order_name: member.name,
            order_email: member.email,
            order_r_name: receiver?.order_name,
            order_r_zip: receiver?.com_zip,
            order_r_addr1: receiver?.com_addr1,
            order_r_addr2: receiver?.com_addr2,
            company_type: member.com_type,
        }

        reset(defaultValues);
    }, [reset, member, receiver]);


    const onSubmit = async (data, e) => {
        e.preventDefault();

        if (list.length === 0) {
            toast.error('상품을 추가해주세요')
            return;
        }

        const formData = new FormData();
        formData.append('user_name', member.username);
        formData.append('order_name', data.order_name);
        formData.append('order_tel', data.phone);
        formData.append('order_email', data.order_email);
        formData.append('order_r_name', data.order_r_name);
        formData.append('order_r_zip', data.order_r_zip);
        formData.append('order_r_addr1', data.order_r_addr1);
        formData.append('order_r_addr2', data.order_r_addr2);
        formData.append('spec_date', data.spec_date);
        formData.append('spec_expire_date', data.spec_expire_date);
        formData.append('company_type', data.company_type);
        formData.append('com_name', data.com_name);
        formData.append('com_charge', data.com_charge);
        formData.append('order_state', "신규주문");
        formData.append('products', JSON.stringify(list));
        
        await apiService.postFormData('/orders/self/checkout', formData)
        .then(response => {
            toast.success('등록 되었습니다');
            navigate(-1);
            
        }).catch(error => {
            console.error(error)
        });

    }

    return (
        <Page title="주문등록">
            <Container>
                <PageHeader
                    title={
                    <Typography variant='h5' color='#666CFF'>
                        주문 등록
                    </Typography>
                    }
                    subtitle={
                    <Alert severity='warning' sx={{mt:2, alignItems: 'center', display: 'flex'}}>
                        회원이 회사정보가 없을 경우, 주문등록이 불가합니다. 회사정보를 등록 후 주문등록을 진행하세요
                        <Link to="/admin/member">
                            <Button variant="contained" color="secondary" sx={{ml: 2}}>회사정보 등록</Button>
                        </Link>                        
                    </Alert>
                    }
                />  
                <form onSubmit={handleSubmit(onSubmit)} id="orderform">

                    <Typography variant="h5" sx={{mt: 8}}>
                        주문자 정보
                    </Typography>

                    <Grid container spacing={6} sx={{mt: 2}}>
                        <Grid item xs={12} md={6}>
                            <Select
                                labelId="target-select-item"
                                id="select-item"
                                value={memfield}
                                onChange={(e) => setMemField(e.target.value)}
                                sx={{ minWidth: 120 }} >
                                    <MenuItem value="username">회원ID</MenuItem>
                                    <MenuItem value="name">회원이름</MenuItem>
                                    <MenuItem value="com_name">업체명</MenuItem>
                            </Select>
                            <TextField
                                value={memq}
                                label='검색어'
                                id='search'
                                onChange={(e) => setMemQ(e.target.value)}
                                placeholder='검색어를 입력해주세요'
                                sx={{ minWidth: 300, marginLeft: '1rem' }}
                                InputProps={{
                                    endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton edge="end" ref={memBtnRef} onClick={handleSearch} sx={{padding: 2, marginRight: 1}}>
                                            <BsSearch />
                                        </IconButton>
                                    </InputAdornment>
                                    ),
                                }}
                            />                        
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormControl component="fieldset" fullWidth>
                                <InputLabel id='staff'>담당자</InputLabel>
                                <Controller                                        
                                    name='com_charge'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=''
                                    render={({ field: { value, onChange } }) => (
                                        <Select
                                            label='Charge'
                                            value={value}
                                            onChange={onChange}
                                            labelId='staff'
                                        >
                                            {
                                                staff.map((item, index) => (
                                                    <MenuItem key={index} value={item.username}>{item.username}</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    )}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>

                    <Grid container spacing={6} sx={{mt: 2}}>
                        <Grid item xs={12}>                            
                            <FormControl component="fieldset" fullWidth>
                                <FormLabel component="legend">업체분류</FormLabel>
                                <Controller
                                    name="company_type"
                                    control={control}
                                    defaultValue="국가연구소"
                                    render={({ field }) => (
                                        <RadioGroup row {...field}>
                                            <FormControlLabel value="국가연구소" control={<Radio />} label="국가연구소" />
                                            <FormControlLabel value="제조업" control={<Radio />} label="제조업" />
                                            <FormControlLabel value="학교" control={<Radio />} label="학교" />
                                            <FormControlLabel value="도소매" control={<Radio />} label="도소매" />
                                        </RadioGroup>
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        
                        <Grid item xs={12} md={6}>    
                            <FormControl fullWidth>
                                <Controller
                                    name='com_name'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}                                            
                                            label='회사명'
                                            id='com_name'
                                            onChange={onChange}
                                            placeholder='이름을 입력해주세요'
                                            error={Boolean(errors.com_name)}
                                            helpertext={errors?.message}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='phone'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}                                            
                                            label='연락처'
                                            id='phone'
                                            onChange={onChange}
                                            placeholder='연락처을 입력해주세요'
                                            error={Boolean(errors.phone)}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>    
                            <FormControl fullWidth>
                                <Controller
                                    name='order_name'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}                                            
                                            label='주문자'
                                            id='order_name'
                                            onChange={onChange}
                                            placeholder='이름을 입력해주세요'
                                            error={Boolean(errors.order_name)}
                                            helpertext={errors?.message}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='order_email'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}                                            
                                            label='이메일'
                                            id='order_email'
                                            onChange={onChange}
                                            placeholder='이메일을 입력해주세요'
                                            error={Boolean(errors.order_email)}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>                                                
                    </Grid>
                    
                    <Stack direction="row" alignItems={"baseline"} spacing={4}>
                        <Typography variant="h5" sx={{mt: 8}}>
                            배송지 정보
                        </Typography>
                        <FormControlLabel control={<Checkbox defaultChecked />} label="주문자 정보 동일 지정" />
                    </Stack>

                    <Grid container spacing={6} sx={{mt: 2}}>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='order_r_name'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}                                            
                                            label='수령인'
                                            id='order_r_name'
                                            onChange={onChange}
                                            placeholder='수령인을 입력해주세요'
                                            error={Boolean(errors.order_r_name)}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='order_r_zip'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            label="우편번호"
                                            variant="outlined"
                                            fullWidth
                                            value={value}
                                            onChange={onChange}
                                            InputProps={{
                                                endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton edge="end" ref={postBtnRef} onClick={handleClick} sx={{padding: 2, marginRight: 1}}>
                                                        <BsSearch />
                                                    </IconButton>
                                                </InputAdornment>
                                                ),
                                            }}
                                            error={Boolean(errors.order_r_zip)}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='order_r_addr1'
                                    control={control}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}                                            
                                            label='주소'
                                            id='order_r_addr1'
                                            onChange={onChange}
                                            placeholder='수령인을 입력해주세요'
                                            inputProps={ { readOnly: true, } }
                                            error={Boolean(errors.order_r_addr1)}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='order_r_addr2'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}                                            
                                            label='상세주소'
                                            id='order_r_addr2'
                                            onChange={onChange}
                                            placeholder='수령인을 입력해주세요'
                                            error={Boolean(errors.order_r_addr2)}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>

                    <Typography variant="h5" gutterBottom sx={{mt: 8}}>
                        주문상품
                    </Typography>
                    <Grid container spacing={6} sx={{mt: 2}}>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='spec_date'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue={dayjs().format("YYYY-MM-DD")}
                                    render={({ field: { value, onChange } }) => (
                                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
                                            <DatePicker
                                                label='주문일'
                                                value={value}
                                                onChange={onChange}
                                                inputFormat={dayjs(value).format("YYYY-MM-DD")}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </LocalizationProvider>
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='spec_expire_date'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue={dayjs().add(7, 'day').format("YYYY-MM-DD")}
                                    render={({ field: { value, onChange } }) => (
                                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
                                            <DatePicker
                                                label='주문유효기간'
                                                value={value}
                                                onChange={onChange}
                                                inputFormat={dayjs(value).format("YYYY-MM-DD")}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </LocalizationProvider>
                                    )}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                </form>

                <Stack direction="row" alignItems={"baseline"} spacing={4} sx={{mt: 4}}>
                    <Button variant='contained' color="warning" sx={{mt: 2}} onClick={() => {setSearchProductShow(true)}}>제품 검색</Button>
                    <Link to="/admin/product/new">
                        <Button color="secondary" variant="contained">제품 등록</Button>
                    </Link>
                </Stack>

                <TableContainer component={Paper}>
                    {
                        list?.length > 0 && 
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Cat.No</TableCell>
                                        <TableCell>제품명</TableCell>
                                        <TableCell>CAS No.</TableCell>
                                        <TableCell>SPEC</TableCell>
                                        <TableCell>용량</TableCell>
                                        <TableCell>수량</TableCell>
                                        <TableCell>단가</TableCell>
                                        <TableCell>공급가액</TableCell>
                                        <TableCell>부가세</TableCell>
                                        <TableCell>납기날짜</TableCell>
                                        <TableCell>Brand</TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        list.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{item.cat_id}</TableCell>
                                                <TableCell>{item.name}</TableCell>
                                                <TableCell>{item.pd_cas}</TableCell>
                                                <TableCell>{item.spec_desc}</TableCell>
                                                <TableCell>{item.pd_packing}</TableCell>
                                                <TableCell>
                                                    <TextField
                                                        title="키보드 위/아래키를 이용하여 수량을 조절할 수 있습니다."
                                                        defaultValue={item.quantity || 1} 
                                                        type="number"
                                                        size="small"
                                                        InputProps={{ 
                                                            inputProps: { min: 1, max: 99 }, 
                                                            sx: { textAlign: 'center', width: '50px'}                                                            
                                                        }}
                                                        onChange={(e) => handleQuantityChange(index, e.target.value)}
                                                    />
                                                </TableCell>
                                                <TableCell>{item.price}</TableCell>
                                                <TableCell>{item.supply_price}</TableCell>
                                                <TableCell>{item.vat}</TableCell>
                                                <TableCell>{item.pd_lead}</TableCell>
                                                <TableCell>{item.brand}</TableCell>
                                                <TableCell align="center">
                                                    <Button variant="contained" color="error" sx={{ color: '#fff !important'}} onClick={() => {handleDelete(index)}} >삭제</Button>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                    }
                </TableContainer>

                <Stack direction="row" alignItems={"baseline"} spacing={4} sx={{mt: 8}}>
                    <TextField label="총공급가액" value={tot_supply} fullWidth margin="normal" />
                    <TextField label="총부가세" value={tot_vat} fullWidth margin="normal" />
                    <TextField label="총주문가액" value={tot_order} fullWidth margin="normal" />
                </Stack>

                <Stack direction="row" spacing={2} sx={{ py: 16, justifyContent: 'center' }}>
                    <Button  type="submit" form="orderform" variant='contained'> 주문등록 </Button>
                    <Button variant='outlined' color='secondary' onClick={() => {navigate(-1)}}>
                        취소
                    </Button>
                </Stack>
            </Container>
            <ProductSearchWindow/>
            <MemberSearchWindow/>
        </Page>
  );
};

export default OrderRegister;
